import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, RotateCcw } from "lucide-react";
import { API, api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Chips } from "@/components/hub/Common";

const STATUSES = ["pending", "approved", "rejected"];

export const GalleryTab = () => {
  const { t } = useI18n();
  const [status, setStatus] = useState("pending");
  const [list, setList] = useState([]);
  const load = useCallback(() => api.get("/admin/gallery", { params: { status } }).then((r) => setList(r.data)).catch(() => setList([])), [status]);
  useEffect(() => { load(); }, [load]);
  const review = async (id, s) => {
    try { await api.post(`/admin/gallery/${id}`, { status: s }); toast.success(t(`adm.gal_${s}_done`)); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="space-y-5" data-testid="admin-gallery">
      <p className="text-sm text-slate-400">{t("adm.gal_intro")}</p>
      <Chips value={status} onChange={setStatus} testid="admin-gallery-filter"
        items={STATUSES.map((s) => [s, t(`stt.feat_${s}`)])} />
      {list.length === 0 && <p className="text-sm text-slate-500 py-10 text-center" data-testid="admin-gallery-empty">{t("adm.gal_empty")}</p>}
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-5">
        {list.map((c) => (
          <div key={c.id} className="cx-card rounded-2xl overflow-hidden" data-testid={`admin-gallery-item-${c.id}`}>
            <video src={`${API}/s/${c.share_id}/video.mp4`} poster={`${API}/s/${c.share_id}/thumb.jpg`} controls muted playsInline
              className={`w-full bg-black object-contain ${c.aspect === "9:16" ? "aspect-[9/16] max-h-[420px]" : c.aspect === "1:1" ? "aspect-square" : "aspect-video"}`} />
            <div className="p-4">
              <div className="text-sm text-white font-semibold truncate">{c.title}</div>
              <div className="text-xs text-slate-500 mt-1 truncate">{c.creator} · {c.views} {t("sh.views")}</div>
              <div className="flex gap-2 mt-4">
                {status !== "approved" && <button onClick={() => review(c.id, "approved")} data-testid={`admin-gallery-approve-${c.id}`} className="flex-1 rounded-lg bg-emerald-500/15 border border-emerald-400/30 text-emerald-300 hover:bg-emerald-500/25 text-xs py-2 flex items-center justify-center gap-1.5"><Check className="w-3.5 h-3.5" />{t("adm.gal_approve")}</button>}
                {status !== "rejected" && <button onClick={() => review(c.id, "rejected")} data-testid={`admin-gallery-reject-${c.id}`} className="flex-1 rounded-lg bg-rose-500/10 border border-rose-400/30 text-rose-300 hover:bg-rose-500/20 text-xs py-2 flex items-center justify-center gap-1.5"><X className="w-3.5 h-3.5" />{t("adm.gal_reject")}</button>}
                {status !== "pending" && <button onClick={() => review(c.id, "pending")} data-testid={`admin-gallery-reset-${c.id}`} className="rounded-lg border border-white/10 text-slate-400 hover:text-white text-xs px-3 py-2"><RotateCcw className="w-3.5 h-3.5" /></button>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
